// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__29Hkw","title":"Images45_title__2mqO7","images":"Images45_images__qn1So"};